
// 도로 안전경보시스템 
export const trafficSafetyProducts = [
  { title: '캐리어형 비상표시장치',
    image: '/images/products/traffic-safety/carrier-emergency-sign.webp',
    detailPath: '/products/traffic-safety/carrier-emergency-sign' },
  { title: '반디별\n(스마트 안전경고 시스템)',
    image: '/images/products/traffic-safety/smart-warning.webp',
    detailPath: '/products/traffic-safety/smart-warning' },
  { title: '불꽃신호기 점화장치',
    image: '/images/products/traffic-safety/pyrotechnic-sign.webp',
    detailPath: '/products/traffic-safety/pyrotechnic-sign' },
  { title: '과속 단속 카메라부스',
    image: '/images/products/traffic-safety/speed-camera-booth.webp',
    detailPath: '/products/traffic-safety/speed-camera-booth' },
  { title: '파노라마 LED 시선유도등',
    image: '/images/products/traffic-safety/panorama-led.webp',
    detailPath: '/products/traffic-safety/panorama-led' },
  { title: '델리네이터',
    image: '/images/products/traffic-safety/delinator.webp',
    detailPath: '/products/traffic-safety/delinator' },
  { title: '차선 규제봉',
    image: '/images/products/traffic-safety/tubular-marker.webp',
    detailPath: '/products/traffic-safety/tubular-marker' },
  { title: '경광등',
    image: '/images/products/traffic-safety/warning-light.webp',
    detailPath: '/products/traffic-safety/warning-light' },
];

// 도로 안전유도시설 
export const guardrailProducts = [
  { title: '디딤-Safe\n(가드레일용 안전발판)',
    image: '/images/products/guardrail/didim-safe.webp',
    detailPath: '/products/guardrail/safety-stairs' },
  { title: '공사중 차로안내 시스템',
    image: '/images/products/guardrail/line-navigator3.jpg',
    detailPath: '/products/guardrail/line-navigator' },
  { title: 'IoT 회차로 차단제어기',
    image: '/images/products/guardrail/IoT.webp',
    detailPath: '/products/guardrail/IoT' },
  { title: '통과높이 제한시설',
    image: '/images/products/guardrail/height-limit.webp',
    detailPath: '/products/guardrail/height-limit' },
  { title: '터널진입 차단시설',
    image: '/images/products/guardrail/tunnel-limit2.jpg',
    detailPath: '/products/guardrail/tunnel-limit' },
  { title: '하이패스 안전시설물',
    image: '/images/products/guardrail/hi-pass2.jpg',
    detailPath: '/products/guardrail/hi-pass' },    
  { title: '터널입구 조명시설',
    image: '/images/products/guardrail/tunnel-entry-light7.webp',
    detailPath: '/products/guardrail/tunnel-entry-light' },
  { title: 'VMS 조명시설',
    image: '/images/products/guardrail/VMS7.jpg',
    detailPath: '/products/guardrail/VMS' },
];

// 도로환경 개선시설 
export const facilitiesProducts = [
  { title: '쉼 in 카\n(이동식근로자쉼터)',
    image: '/images/products/facilities/shelter-bus.webp',
    detailPath: '/products/facilities/shelter-bus' },
  { title: '경찰 순찰차 주차시설(POP)\n조명구조물',
    image: '/images/products/facilities/POP4.jpg',
    detailPath: '/products/facilities/POP' },
  { title: '졸음쉼터 차양시설',
    image: '/images/products/facilities/sleep-shelter.webp',
    detailPath: '/products/facilities/sleep-shelter' },
  { title: '방음벽 및 방음터널시설',
    image: '/images/products/facilities/sound-proof3.jpg',
    detailPath: '/products/facilities/sound-proof' },
  { title: '배너 걸이장치',
    image: '/images/products/facilities/banner.webp',
    detailPath: '/products/facilities/banner' },
];

// 도로 안내표지시스템 
export const signageProducts = [
  { title: '도로 표지판',
    image: '/images/products/signage/road-sign.webp',
    detailPath: '/products/signage/road-sign' },
  { title: '교통안전표지판',
    image: '/images/products/signage/guide-sign2.jpeg',
    detailPath: '/products/signage/guide-sign' },
  { title: '태양광광섬유발광형 교통안전표지판',
    image: '/images/products/signage/solar-fiber-sign.webp',
    detailPath: '/products/signage/solar-fiber-sign' },
  { title: '태양광 LED 내부조명표지판',
    image: '/images/products/signage/solar-led-sign.webp',
    detailPath: '/products/signage/solar-led-sign' },
  { title: '외부 조명용 표지판',
    image: '/images/products/signage/external-light-sign.webp',
    detailPath: '/products/signage/external-light-sign' },
  { title: '갈매기표지판',
    image: '/images/products/signage/seagull-sign3.jpg',
    detailPath: '/products/signage/seagull-sign' },
];
